/**
 * EventSchemaName
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import SchemaName from '../SchemaName';

// Selectors
import { makeSelectEventValue } from '../../services/events/selectors';

interface Props {
    schemaId?: string;
}

export class EventSchemaName extends React.PureComponent<Props> {
    render() {
        const { schemaId } = this.props;
        return <SchemaName schemaId={schemaId} />;
    }
}

const mapStateToProps = createStructuredSelector({
    schemaId: makeSelectEventValue('schemaId')
});

export default connect(mapStateToProps)(EventSchemaName);
